import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { MatDialog } from '@angular/material';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var EmpresaConstructoraComponent = /** @class */ (function () {
    function EmpresaConstructoraComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.rutValidator = rutValidator;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = [];
        this.selectedCon = null;
        this.matcher = new FormService();
        this.rut_consta = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        });
        if (!JSON.parse(localStorage.getItem("constructora"))) {
            localStorage.setItem("constructora", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("constructora"));
        }
        this.invalidRut = true;
        this.constructora = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
    }
    EmpresaConstructoraComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    EmpresaConstructoraComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.options.filter(function (option) { return option.toLowerCase().includes(filterValue); });
    };
    EmpresaConstructoraComponent.prototype.get_Constructora = function (rut) {
        var _this = this;
        this.spinner.show();
        this.cleanData();
        this.cleanData();
        this._userService.getConstructora(rut).subscribe(function (response) {
            if (response.message) {
                _this.constructora.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.constructora.rut = response.rut ? response.rut : '';
                _this.constructora.nombre = response.nombre ? response.nombre : '';
                _this.constructora.direccion = response.direccion ? response.direccion : '';
                _this.constructora.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.constructora.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.constructora.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.constructora.comuna = response.comuna ? response.comuna : '';
                _this.constructora.fono = response.fono ? response.fono : '';
                _this.constructora.fax = response.fax ? response.fax : '';
                _this.constructora.mail = response.mail ? response.mail : '';
                _this.constructora.patente = response.patente ? response.patente : '';
                _this.constructora.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    EmpresaConstructoraComponent.prototype.cleanData = function () {
        this.constructora = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
        this.rut_consta.reset();
    };
    EmpresaConstructoraComponent.prototype.update_Constructora = function (rut, id) {
        this.get_Constructora(rut);
        this.selectedCon = id;
    };
    EmpresaConstructoraComponent.prototype.saveConstructora = function () {
        var _this = this;
        window.scroll(0, 0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.constructora.rut == this.rows[x].rut) {
                this.delete_Constructora(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedCon != null) {
            this.delete_Constructora(this.selectedCon);
            this.selectedCon = null;
        }*/
        this.spinner.show();
        this._userService.saveConstructora(this.constructora).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#const_modal").modal("hide");
                _this.actualRow = localStorage.getItem("constructora");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.constructora.rut,
                    nombre: _this.constructora.nombre,
                    direccion: _this.constructora.direccion,
                    direccion_num: _this.constructora.direccion_num,
                    direccion_complemento: _this.constructora.direccion_complemento,
                    direccion_completa: _this.constructora.direccion_completa,
                    comuna: _this.constructora.comuna,
                    fono: _this.constructora.fono,
                    fax: _this.constructora.fax,
                    patente: _this.constructora.patente
                });
                localStorage.setItem("constructora", JSON.stringify(_this.rows));
                _this.constructora = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
                _this.rut_consta.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    EmpresaConstructoraComponent.prototype.delete_Constructora = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("constructora", JSON.stringify(this.rows));
            }
        }
    };
    EmpresaConstructoraComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return EmpresaConstructoraComponent;
}());
export { EmpresaConstructoraComponent };
